<template>
    <div class="buy-container">
        <v-img
            class="d-flex align-center buy-banner"
            :src="
                $vuetify.breakpoint.smAndUp
                    ? require(`@/assets/bg/where-to-buy-md.jpg`)
                    : require(`@/assets/bg/where-to-buy-xs.png`)
            "
        >
            <div class="top-content page-content buy-title-wrapper">
                <div class="buy-title-group">
                    <p class="buy-title font-weight-bold">
                        Where to Buy
                    </p>
                    <p class="buy-subtitle">
                        Find your nearest Nexon Game Card retailer
                    </p>
                </div>
            </div>
        </v-img>
        <v-tabs
            show-arrows
            centered
            color="#2960e8"
            background-color="white"
            :height="$vuetify.breakpoint.mdAndUp ? '72px' : '60px'"
            class="country-tabs"
        >
            <v-tabs-slider color="#2960e8"></v-tabs-slider>
            <v-tab
                class="country-tab"
                :key="index"
                :ripple="false"
                @click="setCountry(country)"
                v-for="(value, country, index) in this.getRetailers"
                :data-ga="`Country|${country}`"
                >{{ country }}
            </v-tab>
        </v-tabs>
        <section class="retailers-section">
            <v-img
                class="right-shape-image"
                src="../assets/dots-diamond.svg"
            ></v-img>
            <v-img
                class="left-shape-image"
                src="../assets/dots-diamond.svg"
            ></v-img>
            <div class="page-content">
                <v-container class="retailer-list-container pa-0">
                    <v-row class="retailer-type">
                        <v-btn
                            id="inStore-btn"
                            class="font-weight-bold retailer-type-btn btn-left"
                            :class="{
                                'btn-active': retailType === 'inStore',
                            }"
                            @click="getRetailType('inStore')"
                            :ripple="false"
                            text
                            ><span
                                class="btn-text"
                                data-ga="Retailer Type|In-Store"
                                >In-Store Retailers</span
                            ></v-btn
                        >
                        <span class="pipe-spacer">|</span>
                        <v-btn
                            id="online-btn"
                            class="font-weight-bold retailer-type-btn btn-right"
                            :class="{
                                'btn-active': retailType === 'online',
                            }"
                            @click="getRetailType('online')"
                            :ripple="false"
                            text
                            ><span
                                class="btn-text"
                                data-ga="Retailer Type|Online"
                                >Online Retailers</span
                            ></v-btn
                        >
                    </v-row>
                    <v-col cols="12" class="pa-0">
                        <v-slide-y-reverse-transition>
                            <v-row
                                v-if="this.getRetailers[this.country]"
                                align="center"
                                class="grey lighten-5 mx-auto"
                            >
                                <v-card
                                    v-for="(retailer, index) in this
                                        .getRetailers[this.country][
                                        this.retailType
                                    ]"
                                    :key="index"
                                    class="retailer-card d-flex align-center"
                                    outlined
                                    hover
                                    :href="`${retailer.link}`"
                                    target="_blank"
                                    height="168"
                                    width="274"
                                    min-width="274"
                                    :ripple="false"
                                    :data-ga="`Retailer Card|${retailer.name}`"
                                >
                                    <v-img
                                        :src="`${baseURL}${retailer.imageUrl}`"
                                        :lazy-src="
                                            `${baseURL}${retailer.imageUrl}`
                                        "
                                        width="180"
                                        height="110"
                                        contain
                                    >
                                        <template v-slot:placeholder>
                                            <v-row
                                                class="fill-height ma-0"
                                                align="center"
                                                justify="center"
                                            >
                                                <v-progress-circular
                                                    indeterminate
                                                    color="#2960e8"
                                                ></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                </v-card>
                            </v-row>
                        </v-slide-y-reverse-transition>
                    </v-col>
                </v-container>
            </div>
        </section>
    </div>
</template>
<script>
import { getUmbracoEnv } from '@/config/umbraco-env';

export default {
    name: 'retailers',
    data() {
        return {
            country: 'United States',
            retailType: 'inStore',
            baseURL: getUmbracoEnv(),
            isIE11Browser: /Trident.*rv[ :]*11\./.test(navigator.userAgent),
        };
    },
    metaInfo() {
        return {
            titleTemplate: `%s | Where To Buy`,
        };
    },
    computed: {
        getRetailers() {
            return this.$store.state.retailers;
        },
    },
    created() {
        this.$store.dispatch('fetchRetailers');
    },
    methods: {
        setCountry(name) {
            this.country = name;
        },
        getRetailType(type) {
            this.retailType = type;
        },
    },
    watch: {
        country() {
            this.retailType = 'inStore';
        },
    },
};
</script>
<style lang="scss" scoped>
.buy-container {
    background-color: #fafafa;
    .buy-banner {
        position: relative;
        // EDGE ONLY HACK
        @supports (-ms-ime-align: auto) {
            display: -webkit-box !important;
        }
        .buy-title-wrapper {
            position: relative;
            min-height: 460px;
            display: flex;
            justify-content: center;
            .buy-title-group {
                text-align: center;
                margin-top: 30px;
                color: #212843;
                .buy-title {
                    font-size: 36px;
                    margin-bottom: 10px;
                    line-height: 1;
                    font-family: KlavikaNX-Medium, serif;
                    text-transform: uppercase;
                }
                .buy-subtitle {
                    font-size: 16px;
                    margin-bottom: 0;
                }
            }
        }
    }
    .country-tabs {
        box-shadow: 0 10px 50px 0 rgba(0, 0, 0, 0.1);
        .country-tab {
            font-size: 16px;
        }
        .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
            color: black;
        }
    }

    .retailers-section {
        position: relative;
        overflow: hidden;
        width: 100vw;
        min-width: 360px;
        max-width: 100%;
        height: 100%;
        margin-bottom: 100px;
        .right-shape-image {
            position: absolute;
            width: 156px;
            top: 35%;
            right: -78px;
            transform: rotate(-90deg);
        }
        .left-shape-image {
            position: absolute;
            width: 156px;
            top: 65%;
            left: -78px;
            transform: rotate(90deg);
        }
        .retailer-list-container {
            max-width: 304px;
            margin-bottom: 45px;
            .retailer-type {
                min-width: 330px;
                display: flex;
                justify-content: center;
                padding: 52px 0 30px 0;
                .retailer-type-btn {
                    font-size: 16px;
                    color: grey;
                    padding: 0;
                    margin: 0 30px;
                    letter-spacing: normal;
                    .btn-text {
                        white-space: normal;
                        width: 100px;
                    }
                }
                .btn-active {
                    color: black;
                }
                .pipe-spacer {
                    font-size: 20px;
                }
            }
            .retailer-card {
                border-radius: 6px;
                margin: 15px;
                &.v-card--hover:hover {
                    box-shadow: 0 38px 38px -34px rgba(0, 0, 0, 0.55);
                }
            }
        }
    }
}

.v-tab {
    text-transform: capitalize;
    padding: 0 25px;
    &:hover {
        color: #2960e8 !important;
    }
    &:before {
        background-color: transparent !important;
    }
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(0, 0, 0, 1);
}

.v-btn {
    text-transform: none;
    &:hover {
        &:before {
            color: transparent;
        }
        transform: scale(1.05);
    }
    &:focus {
        &:before {
            color: transparent;
        }
    }
    &:before {
        transition: none;
    }
}

.v-card--link {
    &:focus {
        &:before {
            opacity: 0;
        }
    }
}
@include break('sm') {
    .buy-container .buy-banner .buy-title-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .buy-title-group {
            text-align: left;
            margin: -120px auto 0 10px;
            .buy-title {
                font-size: 42px;
                margin-bottom: 25px;
            }
            .buy-subtitle {
                font-size: 14px;
                line-height: 1;
            }
        }
    }
    .buy-container .retailers-section {
        .retailer-list-container {
            max-width: 608px;
            .retailer-type {
                padding: 54px 0 30px 0;
                .retailer-type-btn {
                    .btn-text {
                        width: 160px;
                    }
                }
                .retailer-type-btn.btn-left {
                    text-align: right;
                }
                .retailer-type-btn.btn-right {
                    text-align: left;
                }
            }
        }
    }
}
@include break('md') {
    .buy-container .buy-banner .buy-title-wrapper {
        width: calc(100vw - 76px); // 30px margin on each side + 16px scroll bar
        .buy-title-group {
            margin-left: 55px;
            .buy-title {
                font-size: 50px;
            }
            .buy-subtitle {
                font-size: 16px;
            }
        }
    }
    .buy-container .country-tabs .country-tab {
        font-size: 20px;
    }
    .v-tab {
        padding: 0 45px;
    }
    .buy-container .retailers-section .retailer-list-container {
        max-width: 1216px;
    }
}
@include break('lg') {
    .buy-container .buy-banner .buy-title-wrapper {
        width: calc(
            100vw - 132px
        ); // 58px margin on each side + 16px scroll bar
        .buy-title-group {
            margin-left: 100px;
            .buy-title {
                font-size: 60px;
            }
            .buy-subtitle {
                font-size: 20px;
            }
        }
    }
    .buy-container .retailers-section {
        .retailer-list-container {
            max-width: 1216px;
            .retailer-type {
                padding: 60px 0 40px 0;
                .retailer-type-btn {
                    margin: 0 40px;
                    .btn-text {
                        font-size: 20px;
                    }
                }
            }
        }
    }
}
@include break('xl') {
    .buy-container .retailers-section .retailer-list-container {
        max-width: 1520px;
    }
}

@media (max-width: 1232px) {
    .buy-container .retailers-section .retailer-list-container {
        max-width: 912px;
    }
}
@media (max-width: 928px) {
    .buy-container .retailers-section .retailer-list-container {
        max-width: 608px;
    }
}

@media (max-width: 624px) {
    .buy-container .retailers-section .retailer-list-container {
        max-width: 304px;
    }
}
</style>
